import './mainMenu.scss'
import templateUrl from './mainMenu.html'

/**
 * Main Menu component.
 *
 * The menu contains {@link TmrRoute routes} that:
 * - Are children or grandchildren of `app`
 * - Have a `mainMenu` option set to `true`
 * - The user can access
 *
 * @example
 * <tmr-main-menu></tmr-main-menu>
 *
 * @type {ngComponent}
 */
export const tmrMainMenu = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrMainMenuController',
}

/**
 * Controller of component {@link tmrMainMenu}.
 *
 * @type {ngController}
 */
export class tmrMainMenuController {
  static ngType = 'controller'

  constructor($state, UserStorage, TmrLocalStorage) {
    'ngInject'
    Object.assign(this, {
      $state,
      UserStorage,
      TmrLocalStorage,
      states: $state.router.stateRegistry.states,
    })
  }

  $onInit() {
    this.menuItems = []
    this.buildMenu()
  }

  buildMenu() {
    // 2nd level items (mainMenu = parent state name)
    let childrenStates = {}
    for (let name in this.states) {
      let s = this.states[name]
      if (this.inMenu(s) && typeof s.mainMenu === 'string') {
        childrenStates[s.mainMenu] = childrenStates[s.mainMenu] ?? []
        childrenStates[s.mainMenu].push({
          name,
          label: s.label,
          url: s.url,
          weight: s.weight,
        })
      }
    }

    // 1st level items (mainMenu = true)
    for (let name in this.states) {
      let state = this.states[name]
      if (
        this.inMenu(state) &&
        state.mainMenu === true &&
        (state.url || childrenStates[name])
      ) {
        this.menuItems.push({
          name,
          label: state.label,
          // Abstract states may have base urls, don't link to them.
          url: state.abstract ? null : state.url,
          weight: state.weight,
          children: childrenStates[name] ?? [],
          submenuClosed: !(
            this.TmrLocalStorage.get('activeMenuItem', '') == state.name
          ),
          icon: state.icon,
        })
      }
    }
  }

  /** Checks if a state should be visible in the menu. */
  inMenu(state) {
    return (
      state.parent &&
      (state.mainMenu === true || typeof state.mainMenu === 'string') &&
      this.UserStorage.access(state)
    )
  }

  /** manage click on menu item */
  onMenuClick(menuItem) {
    /** add logic to save last menu opened into localstorage */
    if (menuItem.submenuClosed)
      this.TmrLocalStorage.set('activeMenuItem', menuItem.name)
    else this.TmrLocalStorage.clear('activeMenuItem')

    if (menuItem.url) return this.$state.go(menuItem.name)
    this.menuItems.forEach(
      element =>
        (element.submenuClosed =
          element.name == menuItem.name ? !menuItem.submenuClosed : true)
    )
  }

  /** Check if the active state is children of menuItem and (the menu-level-1 is closed or menubar is collapsed) */
  hasActiveChild(menuItem) {
    return (
      this.$state.includes(menuItem.name) &&
      (!this.isExpanded() || menuItem.submenuClosed)
    )
  }

  /** Returns true if the sidebar is expanded */
  isExpanded() {
    return this.TmrLocalStorage.get('sidebarExpanded', true)
  }
}
